import React from "react"

interface FireIconProps {
	className: string
}

export function FireIcon({className}: FireIconProps) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" className={className}>
			<path
				fill="#fff"
				d="M17.305 14.344a5.21 5.21 0 0 1-4.211 4.211.563.563 0 1 1-.188-1.11c1.63-.274 3.012-1.658 3.289-3.289a.563.563 0 0 1 1.11.188Zm3.008-.844a8.062 8.062 0 1 1-16.125 0c0-2.575 1.017-5.213 3.023-7.841a.562.562 0 0 1 .844-.063l2.47 2.396 2.164-5.935a.562.562 0 0 1 .888-.24c2.022 1.683 6.736 6.19 6.736 11.683Zm-1.125 0c0-4.537-3.624-8.422-5.726-10.294L11.28 9.193a.562.562 0 0 1-.92.211L7.732 6.852c-1.608 2.254-2.42 4.492-2.42 6.648a6.938 6.938 0 1 0 13.875 0Z"
			/>
		</svg>
	)
}
